import React from 'react';

const Loader = ({ mensaje = "Cargando..." }) => {
    return (
        <div className="flex flex-col items-center justify-center h-full w-full">
            <div className="w-12 h-12 border-4 border-purple-500 border-t-transparent rounded-full animate-spin"></div>
            <p className="mt-4 text-sm text-gray-600">{mensaje}</p>
        </div>
    );
};

export default Loader;
